const compareHardware = (item1, item2) => {
  const WEIGHT_WEIGHT = 3;
  const AUDIO_WEIGHT = 2;
  const MIC_WEIGHT = 2;
  const WIRELESS_WEIGHT = 2;
  const STANDALONE_WEIGHT = 2;

  const itemWeight = (item, compareResult) => {
    let weight = 0;
    if (item.weight === compareResult.weight) {
      weight += WEIGHT_WEIGHT;
    }
    if (item.audio === compareResult.audio) {
      weight += AUDIO_WEIGHT;
    }
    if (item.mic === compareResult.mic) {
      weight += MIC_WEIGHT;
    }
    if (item.wireless === compareResult.wireless) {
      weight += WIRELESS_WEIGHT;
    }
    if (item.standalone === compareResult.standalone) {
      weight += STANDALONE_WEIGHT;
    }
    return weight;
  };

  const compareWeight = (weight1, weight2) => {
    if (!weight1) return weight2;
    if (!weight2) return weight1;
    return weight1 < weight2 ? weight1 : weight2;
  };

  const compareResult = {
    weight: compareWeight(item1.weight, item2.weight),
    audio: true,
    mic: true,
    wireless: true,
    standalone: true,
  };

  const itemWeight1 = itemWeight(item1, compareResult);
  const itemWeight2 = itemWeight(item2, compareResult);

  if (itemWeight1 === itemWeight2) {
    return [item1, item2];
  }
  return itemWeight1 > itemWeight2 ? [item1] : [item2];
};

module.exports = compareHardware;
